module.exports = __webpack_public_path__ + "static/16-a26b2ff956054adb8185b0f6ee53b8de.jpg";